import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Styles/tokens.css';
import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// FontAwesome injects its stylesheet as a runtime <style> element by default,
// which style-src 'self' blocks — the icons then render as 0x0 SVGs because
// `.svg-inline--fa { height: 1em }` never applies. The import above hands the real
// stylesheet to webpack instead; this switches the injection off. Must run before
// the first icon renders.
fontAwesomeConfig.autoAddCss = false;

// const msalInstance = new PublicClientApplication(msalConfig);

// if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
// }
// msalInstance.addEventCallback((event) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     console.log(event);
//     const account = event.payload.account;
//     msalInstance.setActiveAccount(account);
//   }
// });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* <App instance={msalInstance}/> */}
        <App />
    </React.StrictMode>
);

const loader = document.getElementById('unixi_management_loader');
if (loader) {
    loader.classList.add('is-hidden');
    setTimeout(() => {
        document.getElementById('unixi_management_loader')?.remove();
    }, 1600);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
